import React, { useState, useEffect } from "react";
import Calendar, { CalendarTileProperties } from "react-calendar";
import "./calendar.css";

const prevlabel = (
  <svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      d="M13.2596 2.46071C13.2596 2.76378 13.1437 3.06685 12.8933 3.33624L5.12618 11.7265L12.9699 19.8582C13.6408 20.5869 13.368 21.5688 12.3569 22.0524C11.3496 22.5387 9.98155 22.342 9.31062 21.6146L0.65768 12.6061C0.164295 12.0754 0.160556 11.383 0.653942 10.8496L9.23026 1.58249C9.90306 0.852432 11.2711 0.655774 12.2803 1.13934C12.9176 1.44645 13.2596 1.94887 13.2596 2.46071Z"
      fill="#F7A246"
    />
  </svg>
);
const nextLabel = (
  <svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      d="M0.0779467 20.7331C0.0779467 20.4301 0.193818 20.127 0.444249 19.8576L8.21134 11.4673L0.367623 3.33567C-0.303307 2.60696 -0.0304489 1.62502 0.980618 1.14145C1.98795 0.655197 3.35597 0.851854 4.0269 1.57922L12.6798 10.5878C13.1732 11.1185 13.177 11.8108 12.6836 12.3442L4.10727 21.6114C3.43447 22.3414 2.06644 22.5381 1.05724 22.0545C0.419951 21.7474 0.0779467 21.245 0.0779467 20.7331Z"
      fill="#F7A246"
    />
  </svg>
);
type Detail = "month" | "year" | "decade" | "century";

type Props = {
  date: Date;
  maxDate?: Date;
  minDate?: Date;
  onChange: (date: Date) => void;
};
export default function CalendarCard({ date, maxDate, minDate, onChange }: Props) {
  var [curDate, setCurDate] = useState(date);

  const onChangeDate = (date: Date) => {
    setCurDate(date);
    onChange(date);
  };

  useEffect(() => {
    setCurDate(date);
  }, [date]);

  const getTileClassName = (props: CalendarTileProperties) => {
    var tempDate = new Date(props.date);
    if (tempDate.toDateString() === curDate.toDateString()) {
      return "selectedTile";
    }
    // if (tempDate.getDate() % 5 === 0) return "boldTile";
    return "customTile";
  };

  const getNavLabel = (props: { date: Date; view: Detail; label: string }) => {
    return <div className="navLabel">{props.label}</div>;
  };

  return (
    <div>
      <Calendar
        value={curDate}
        tileClassName={getTileClassName}
        className={["mycalendar"]}
        prevLabel={prevlabel}
        nextLabel={nextLabel}
        next2Label={null}
        prev2Label={null}
        onChange={(date) => {
          onChangeDate(date as Date);
        }}
        maxDate={maxDate}
        minDate={minDate}
        navigationLabel={getNavLabel}
        showNeighboringMonth={false}
      />
    </div>
  );
}
